import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DashboardService } from 'src/app/services/dashboard.service';

@Component({
  selector: 'app-showtargetpopup',
  templateUrl: './showtargetpopup.component.html',
  styleUrls: ['./showtargetpopup.component.scss']
})
export class ShowtargetpopupComponent implements OnInit {
  
  data: any = [];
  dataSource = new MatTableDataSource(this.data);
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;  
  @ViewChild(MatSort, { static: false }) sort: MatSort;

  displayedColumns: string[] = [
    "product",
    // "totalBookingCount",
    // "RequestedMachinery",
    "AllocatedTarget",
    "Remaining",
    // "inProgressTarget",
    // "Utilized",
  ];
  filterData: any;

  constructor( @Inject(MAT_DIALOG_DATA) public dataRecievedData: any,
    public dialogRef: MatDialogRef<ShowtargetpopupComponent>,
    private dashboardService:DashboardService) { }

  ngOnInit(): void {
    this.getDetails();
  }

  getBgColorgrid(item: any) {
    if(item.totalTarget == 0 && item.assignedTarget == 0){
      return "#000";
   }else if(item.totalTarget < item?.assignedTarget){
     return "#D54545";
   }else if(item.totalTarget == item?.assignedTarget && item.totalTarget != 0){
     return "#417541";
   }else{
     return "#1E8EE1";
   }       
 }

 applyFilter1(event: any) {
  const filterValue = (event.target as HTMLInputElement).value;
  this.dataSource.filter = filterValue.trim().toLowerCase();
  if (this.dataSource.paginator) {
    this.dataSource.paginator.firstPage();
  }
}

  cancel(){
this.dialogRef.close();
  }

  getDetails()
  {
    this.dashboardService.getDashboardDrillData(this.dataRecievedData, true).subscribe((res) => {
      this.data=res
      this.filterData = this.data.filter((i) => i.totalTarget != 0 );

      this.dataSource = new MatTableDataSource(this.filterData);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
    })

  }

}
